import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery,takeLatest } from 'redux-saga/effects';
import * as _ from 'underscore';

import { CheckHasUnseenUserNotifications,DeleteUserNotification, GetUserNotifications, UpdateLastSeenUserNotification, UpdateUserNotificationsStatus } from '../../../app/actions/AppActionTypes';
import { requestFailed } from '../../../app/actions/RequestFailedAction';
import { Messages } from '../../../codegen/Localize';
import { CommonErrorCode } from '../../../ts/helpers/ErrorCodes';
import { UserNotificationsResources } from '../../resources/UserNotificationsResource';
import { CheckHasUnseenUserNotificationsAction, checkHasUnseenUserNotificationsSucceededAction } from '../actions/CheckHasUnseenUserNotificationsAction';
import { ClearUserNotificationsStateAction,clearUserNotificationsStateAction } from '../actions/ClearUserNotificationsStateAction';
import { DeleteUserNotificationAction, deleteUserNotificationSucceededAction } from '../actions/DeleteUserNotification';
import { GetUserNotificationsAction, getUserNotificationsFailedAction,getUserNotificationsSucceededAction } from '../actions/GetUserNotificationsAction';
import { UpdateLastSeenUserNotificationAction,updateLastSeenUserNotificationAction, updateLastSeenUserNotificationSucceededAction } from '../actions/UpdateLastSeenUserNotificationAction';
import { UpdateUserNotificationsStatusAction, updateUserNotificationsStatusSucceededAction } from '../actions/UpdateUserNotificationStatusAction';
import { GetUserNotificationsResult } from '../GetUserNotificationsResult';

export function* handleGetUserNotificationRequest(action: GetUserNotificationsAction) {
  try {
    const notificationsResult: GetUserNotificationsResult = yield call(getUserNotificationsRequest, action.nextPageToken);
    yield put(getUserNotificationsSucceededAction(notificationsResult));

    if (!_.isEmpty(notificationsResult.notificationDict)) {
      const lastSeenId = _.max(_.values(notificationsResult.notificationDict), n => n.creationTime).id;
      yield put(updateLastSeenUserNotificationAction(lastSeenId));
    }
  } catch (e) {
    yield put(getUserNotificationsFailedAction());
  }
}

export function* handleUpdateUserNotificationsStatusRequest(action: UpdateUserNotificationsStatusAction) {
  try {
    yield call(updateUserNotificationsStatusRequest, action.notificationIds, action.isRead);
    yield put(updateUserNotificationsStatusSucceededAction(action.notificationIds, action.isRead));
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function* handleDeleteUserNotificationRequest(action: DeleteUserNotificationAction) {
  try {
    yield call(deleteUserNotificationRequest, action.notificationId);
    yield put(deleteUserNotificationSucceededAction(action.notificationId));
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function* handleCheckHasUnseenUserNotificationsRequest(action: CheckHasUnseenUserNotificationsAction) {
  try {
    const hasUnseen: boolean = yield call(checkHasUnseenUserNotificationsRequest);
    yield put(checkHasUnseenUserNotificationsSucceededAction(hasUnseen));
  } catch (e) {
    if (e === CommonErrorCode.InvalidSession) {
      yield put(requestFailed(e, Messages.errorUnknown()));
    }
  }
}

export function* handleUpdateLastSeenUserNotificationRequest(action: UpdateLastSeenUserNotificationAction) {
  try {
    yield call(updateLastSeenUserNotificationRequest, action.lastSeenUserNotificationId); // TODO: finalize param
    yield put(updateLastSeenUserNotificationSucceededAction());
  } catch (ignored) {
  }
}

export function* handleClearUserNotificationsState(action: ClearUserNotificationsStateAction) {
  yield put(clearUserNotificationsStateAction());
}

export function getUserNotificationsRequest(nextPageToken: string): Promise<GetUserNotificationsResult> {
  return Promise.resolve(UserNotificationsResources.getUserNotificationsPage(nextPageToken));
}

export function updateUserNotificationsStatusRequest(ids: string[], isRead: boolean): Promise<{}> {
  const batchedIds = _.chunk(ids, 1000);
  return Promise.all(batchedIds.map((batch: string[]) => UserNotificationsResources.updateNotificationsStatus(batch, isRead)));
}

export function deleteUserNotificationRequest(id: string): Promise<{}> {
  return UserNotificationsResources.deleteNotification(id);
}

export function checkHasUnseenUserNotificationsRequest(): Promise<boolean> {
  return UserNotificationsResources.checkHasUnseenUserNotifications();
}

export function updateLastSeenUserNotificationRequest(id: string) {
  return UserNotificationsResources.updateLastSeenUserNotification(id);
}

export function* rootUserNotificationSagas(): SagaIterator {
  yield takeLatest(GetUserNotifications, handleGetUserNotificationRequest);
  yield takeEvery(UpdateUserNotificationsStatus, handleUpdateUserNotificationsStatusRequest);
  yield takeEvery(DeleteUserNotification, handleDeleteUserNotificationRequest);
  yield takeLatest(CheckHasUnseenUserNotifications, handleCheckHasUnseenUserNotificationsRequest);
  yield takeLatest(UpdateLastSeenUserNotification, handleUpdateLastSeenUserNotificationRequest);
}